let variants_list = [];
let gift_variants_list = [];
let selected_variant;
let selected_selling_plan;
let no_months_text;

document.addEventListener('DOMContentLoaded', function() {
    // Initialize subscription functionality
    initSubscriptionModule();
});

function initSubscriptionModule() {
    setupSubscribeSizeClicks();
    setupSubscribeLengthClicks();
    setupCartButtonClicks();
    handleNextButtonClick();
    setupIndicatorClicks(); 
}

function setupSubscribeSizeClicks() {
    document.querySelectorAll('.SubscribeSize-block').forEach(function(block) {
        block.addEventListener('click', function() {
            // Prevent action if the block is blocked (sold out)
            if (this.classList.contains('blocked')) {
                return;
            }

            document.querySelectorAll('.SubscribeSize-block').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            let size_msg = this.getAttribute('attr-msg');
            variants_list = this.getAttribute('attr-variants').split(",");
            gift_variants_list = this.getAttribute('attr-gift-variants').split(",");
            selected_selling_plan = this.getAttribute('attr-sellingplan');

            console.log('[Subscription Debug] 🎁 Gift variants loaded:', gift_variants_list);

            document.getElementById('js-subscribe-toLength').disabled = false;
            document.getElementById('js-size-info').textContent = size_msg;
            document.getElementById('js-size-info').style.display = 'block';

            handlePricing(this);
            scrollToElement('js-subscribe-toLength');
        });
    });
}

function setupSubscribeLengthClicks() {
    document.querySelectorAll('.SubscribeLength-block').forEach(function(block) {
        block.addEventListener('click', function() {
            // Prevent action if the block is blocked (sold out)
            if (this.classList.contains('blocked')) {
                return;
            }
            document.querySelectorAll('.SubscribeLength-block').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            selected_variant = this.getAttribute('attr-variant');
            let length_msg = this.getAttribute('attr-var-msg');
            no_months_text = this.querySelector('.SubscribeLength-blockSubtitle').textContent;
            
            document.getElementById('js-subscribe-toCart2').disabled = false;
            document.getElementById('js-length-info').textContent = length_msg;
            document.getElementById('js-length-info').style.display = 'block';
            scrollToElement('js-subscribe-toCart2');
        });
    });
}

function getSelectedVariantGiftInfo() {
    if (!selected_variant || !variants_list.length || !gift_variants_list.length) {
        return {
            variantId: null,
            giftVariantId: null,
            hasGift: false
        };
    }
    
    const variantId = variants_list[selected_variant];
    const giftVariantId = gift_variants_list[selected_variant];
    const hasGift = giftVariantId && giftVariantId !== 'null' && giftVariantId.trim() !== '';
    
    return {
        variantId,
        giftVariantId,
        hasGift
    };
}

function setupCartButtonClicks() {
    document
      .getElementById("js-subscribe-toCart2")
      .addEventListener("click", function () {
        if (!selected_variant || variants_list.length === 0) {
          console.error("No variant selected or variants list is empty.");
          return;
        }

        console.log("selected_selling_plan", selected_selling_plan);
  
        const giftInfo = getSelectedVariantGiftInfo();
        console.log('[Subscription Debug] 🔍 Variant gift info:', giftInfo);
        
        let data = {
          id: giftInfo.variantId,
          quantity: 1,
          selling_plan: selected_selling_plan,
        };
  
        ajaxAddToCart(data)
          .then(() => {
            const themeSettings = window.autoGiftSettings || {};
  
            console.log("[Subscription Debug] 🔧 AutoGift settings:", themeSettings);
  
            const autoGiftEnabled = themeSettings.enable;
            const discountCode = themeSettings.discount_code;
            const applyDiscount = themeSettings.apply_discount;
            
            console.log('[Subscription Debug] 🤔 Auto Gift check:', {
              autoGiftEnabled,
              applyDiscount,
              hasGiftVariant: giftInfo.hasGift,
              gift_variant_id: giftInfo.giftVariantId
            });
  
            if (autoGiftEnabled && applyDiscount && giftInfo.hasGift) {
              console.log("[Subscription Debug] ✅ Adding gift variant to cart:", giftInfo.giftVariantId);
  
              return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: Number(giftInfo.giftVariantId), quantity: 1 }),
              })
                .then(() => {
                  console.log("[Subscription Debug] 🎁 Gift added successfully ✅");
  
                  if (applyDiscount && discountCode) {
                    console.log(`[Subscription Debug] 🎟️ Redirecting with discount: ${discountCode}`);
                    window.location.href = `/discount/${discountCode}?redirect=/cart`;
                  } else {
                    console.log("[Subscription Debug] 🛒 Redirecting to cart");
                    window.location.href = "/cart";
                  }
                })
                .catch((err) => {
                  console.error("[Subscription Debug] ❌ ERROR adding gift product:", err);
                  window.location.href = "/cart";
                });
            } else {
              console.log("[Subscription Debug] ➡️ No Auto Gift for this variant - redirecting normally");
              window.location.href = "/cart";
            }
          })
          .catch((err) =>
            console.error("Error adding subscription product to cart:", err)
          );
      });
  }
  
  



function handlePricing(element) {
    // Logic to update pricing based on selected options
}


function scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        window.scrollTo({
            top: element.offsetTop - 200,
            behavior: 'smooth'
        });
    }
}

function ajaxAddToCart(data) {
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(response => response.json());
}


function handleNextButtonClick() {
    const nextButton = document.getElementById('js-subscribe-toLength');
    nextButton.addEventListener('click', function() {
        const activeBlock = document.querySelector('.SubscribeSize-block.active');

        // Special case for bracelet block
        if (activeBlock && activeBlock.classList.contains('bracelet-block')) {
            window.location.href = '/products/poppy-bracelet-subscription-2022';
            return;
        }

        // Hide and show subscription steps
        document.getElementById('js-subscribe-1').style.display = 'none';
        document.getElementById('js-subscribe-2').style.display = 'block';

        // Update indicators
        updateIndicators();

        // Scroll to section on mobile
        scrollToSectionOnMobile();
    });
}

function updateIndicators() {
    const ind1 = document.querySelectorAll('.js-ind-1 .SubscribeIndicator-circle');
    const ind2 = document.querySelectorAll('.js-ind-2 .SubscribeIndicator-circle');

    ind1.forEach(ind => {
        ind.classList.remove('active', 'blocked');
    });

    ind2.forEach(ind => {
        ind.classList.add('active');
        ind.classList.remove('blocked');
    });
}

function selected_variant_id_from_active_block() {
    const activeBlock = document.querySelector('.SubscribeSize-block.active');
    if (activeBlock) {
        return activeBlock.getAttribute('data-variant-id');  // Make sure this is the correct attribute name
    }
    return null;  // Return null if no active block or no ID found
}


function scrollToSectionOnMobile() {
    if (window.matchMedia("(max-width: 767px)").matches) {

    
        const subscribeLengthSection = document.querySelector('#js-subscribe-2');
        if (subscribeLengthSection) {
            window.scrollTo({
                top: subscribeLengthSection.offsetTop,
                behavior: 'smooth'
            });
        }
    }
}

function setupIndicatorClicks() {
    const ind1Circle = document.querySelector('.js-ind-1 .SubscribeIndicator-circle');
    const ind2Circle = document.querySelector('.js-ind-2 .SubscribeIndicator-circle');

    if (ind1Circle) {
        ind1Circle.addEventListener('click', function() {
            this.classList.add('active');

            if (ind2Circle) {
                ind2Circle.classList.remove('active');
                ind2Circle.classList.add('blocked');
            }

            document.getElementById('js-subscribe-1').style.display = 'block';
            document.getElementById('js-subscribe-2').style.display = 'none';
        });
    }
}


document.addEventListener('DOMContentLoaded', function() {
    initGiftRedemptionFlow();
});

function initGiftRedemptionFlow() {
    const giftRedemptionBlocks = document.querySelectorAll('.GiftRedemption-block');
    const giftRedemptionLengths = document.querySelectorAll('.GiftRedemption-length');
    const buttonRed = document.getElementById('js-btn-red');

    giftRedemptionBlocks.forEach(block => {
        block.addEventListener('click', function() {
            // Prevent action if the block is blocked (sold out)
            if (this.classList.contains('blocked')) {
                return;
            }
            giftRedemptionBlocks.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            updateButtonState();
        });
    });

    giftRedemptionLengths.forEach(length => {
        length.addEventListener('click', function() {
            // Prevent action if the length is blocked (sold out)
            if (this.classList.contains('blocked')) {
                return;
            }
            giftRedemptionLengths.forEach(l => l.classList.remove('active'));
            this.classList.add('active');
            updateButtonState();
        });
    });

    buttonRed.addEventListener('click', function() {
        const selectedProduct = document.querySelector('.GiftRedemption-block.active');
        if (selectedProduct) {
            const variantID = selectedProduct.getAttribute('attr-variant');
            const sellingPlanId = selectedProduct.getAttribute('attr-sellingplan');

            const data = {
                id: variantID,
                quantity: 1,
                selling_plan: sellingPlanId,
                properties: {
                    shipping_interval_frequency: "1",
                    shipping_interval_unit_type: "months",
                    charge_interval_frequency: "1",
                }
            };

            addToCart(data);
        }
    });
}

function updateButtonState() {
    const hasActiveBlock = document.querySelector('.GiftRedemption-block.active') !== null;
    const hasActiveLength = document.querySelector('.GiftRedemption-length.active') !== null;
    const buttonRed = document.getElementById('js-btn-red');

    if (hasActiveBlock && hasActiveLength) {
        buttonRed.disabled = false;
    } else {
        buttonRed.disabled = true;
    }
}

function addToCart(data) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        console.log('Item added to cart:', data);
        window.location.replace("/cart");
        //window.location.replace("/checkout");
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
    });
}

